import classes from './SupplierActivityList.module.scss';
import React, { ReactNode } from 'react';
import { ActivitySearchResult } from 'types';
import { Supplier } from 'interfaces';
import ActivityListingsEmbed from '../ActivityListings/ActivityListingsEmbed';

interface ISupplierActivitiesProps {
  activities: ActivitySearchResult[] | null;
  error: boolean;
  rawError?: string;
  totalActivitiesCount: number;
  supplier: Supplier | null;
  page: string;
  categoryName?: string;
  categorySlug?: string;
  children: ReactNode;
}

const SupplierActivityListEmbed: React.FC<ISupplierActivitiesProps> = (props) => {
  const { activities, children } = props;

  return (
    <div className={classes.searchResultsPageWrapper}>
      <div className={classes.supplierActivitiesContainer}>
        <ActivityListingsEmbed activities={activities || []} error={props.error} />
        {children}
      </div>
    </div>
  );
};

export default SupplierActivityListEmbed;
